<!-- qr-scanner.component.html -->
<div class="qr-scanner">
  <div class="w-100 mb-4">
    <input
      type="text"
      class="lum-input scanned-value w-100"
      matInput
      disabled
      [(ngModel)]="scannedValue"
      placeholder="Scanned value"
      *ngIf="scanner.isStart"
    />
  </div>
  <div class="w-100 mb-4">
    <select
      [ngModel]="null"
      (ngModelChange)="onSelectDevice($event)"
      class="form-select form-select-sm"
    >
      <option [value]="null" selected>Select device</option>
      <option
        *ngFor="let c of scanner.devices.value; let i = index"
        [ngValue]="c.deviceId"
        [selected]="i == selectedDevice"
        >{{ c.label }}</option
      >
    </select>
  </div>
  <ngx-scanner-qrcode
    class="mb-4"
    #scanner
    [config]="scannerConfig"
    (event)="onScanned($event)"
    [isBeep]="shouldBeep"
    [ngClass]="{ 'qr-scanner-active': scanner.isStart }"
  ></ngx-scanner-qrcode>
  <div class="flex gap-4 w-100 mb-4">
    <button
      class="lum-button lum-button--secondary lum-button--large w-100"
      (click)="scanner.isStart ? scanner.stop() : openScanner()"
    >
      {{ scanner.isStart ? 'Close' : 'Open Scanner' }}
    </button>
  </div>

  <div
    class="loading-screen"
    *ngIf="scanner.isLoading || isLoading"
    [ngClass]="{ 'loading-screen-active': scanner.isLoading }"
  >
    <div class="spinner"></div>
    <p>Loading...</p>
  </div>
</div>
